import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center px-6" data-testid="not-found-page">
      <p className="overline mb-4">Error 404</p>
      <h1 className="font-display text-6xl md:text-8xl tracking-tighter uppercase mb-4">Not found</h1>
      <p className="text-slate-600 mb-8">This deal must have expired.</p>
      <Link to="/" className="px-6 py-3 bg-slate-950 text-white rounded-sm font-medium hover:bg-emerald-500 hover:text-slate-950 transition-colors">
        Back to home
      </Link>
    </div>
  );
}
